import { RISK_LOWER_THRESHOLD, RISK_UPPER_THRESHOLD } from '@/constants/risks';
import { formatRiskDecimal } from './format-risk-decimal';

export const colorFromRisk = (
  risk: number,
  averageRisk: number
): {
  color: string;
  backgroundColor: string;
  textColor: string;
} => {
  const riskPercentage = parseFloat(formatRiskDecimal(risk));
  const averageRiskPercentage = parseFloat(formatRiskDecimal(averageRisk));

  if (riskPercentage > averageRiskPercentage * RISK_UPPER_THRESHOLD) {
    return { color: '#FF9473FF', backgroundColor: '#FF9473FF', textColor: 'white' };
  } else if (riskPercentage < averageRiskPercentage * RISK_LOWER_THRESHOLD) {
    return { color: '#7CF1C7FF', backgroundColor: '#7CF1C7FF', textColor: 'black' };
  } else {
    return { color: 'white', backgroundColor: 'white', textColor: 'black' };
  }
};

export const tailwindColorsFromRisk = (
  risk: number,
  averageRisk: number
): string => {
  const riskPercentage = parseFloat(formatRiskDecimal(risk));
  const averageRiskPercentage = parseFloat(formatRiskDecimal(averageRisk));

  if (riskPercentage > averageRiskPercentage * RISK_UPPER_THRESHOLD) {
    return 'bg-[#FF9473FF] text-white';
  } else if (riskPercentage < averageRiskPercentage * RISK_LOWER_THRESHOLD) {
    return 'bg-[#7CF1C7FF] text-black';
  } else {
    return 'bg-white text-black';
  }
};
